"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = __importDefault(require("../../client"));
const path = (id) => `/event/${id}/players`;
function addPlayers(auth, event, players, playerType) {
    if (!Array.isArray(players)) {
        throw new Error('players must be an array');
    }
    if (playerType !== undefined) {
        if (playerType !== 'team' && playerType !== 'individual') {
            throw new Error('player type must be team or individual');
        }
    }
    const eventId = event.split(':')[1];
    const data = {
        players,
        playerType: playerType !== null && playerType !== void 0 ? playerType : 'team',
    };
    return client_1.default.post(path(eventId), data, {
        headers: {
            Authorization: auth,
        },
    });
}
exports.default = addPlayers;
